module.exports = __webpack_public_path__ + "img/icon-transactions.f3e1f2d5.svg";